const timezoneMap: Record<string, string> = {
  'Pacific Standard Time': 'America/Los_Angeles',
  'Mountain Standard Time': 'America/Denver',
  'Central Standard Time': 'America/Chicago',
  'Eastern Standard Time': 'America/New_York',
  'Alaska Standard Time': 'America/Anchorage',
  'Hawaii Standard Time': 'Pacific/Honolulu',
  'Atlantic Standard Time': 'America/Halifax',
  'Pacific Daylight Time': 'America/Los_Angeles',
  'Mountain Daylight Time': 'America/Denver',
  'Central Daylight Time': 'America/Chicago',
  'Eastern Daylight Time': 'America/New_York',
  'Alaska Daylight Time': 'America/Anchorage',
  'Atlantic Daylight Time': 'America/Halifax',
  PST: 'America/Los_Angeles',
  PDT: 'America/Los_Angeles',
  MST: 'America/Denver',
  MDT: 'America/Denver',
  CST: 'America/Chicago',
  CDT: 'America/Chicago',
  EST: 'America/New_York',
  EDT: 'America/New_York',
  AKST: 'America/Anchorage',
  AKDT: 'America/Anchorage',
  HST: 'Pacific/Honolulu',
  AST: 'America/Halifax',
  ADT: 'America/Halifax'
};

export const getUserTimezone = (): string => {
  const fullTimezone =
    document.querySelector('body')?.getAttribute('data-timezone') || 'Pacific Standard Time';

  // For Firefox, use IANA timezone name
  if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
    return timezoneMap[fullTimezone] || 'America/Los_Angeles';
  }

  // For other browsers, keep existing abbreviation logic
  return fullTimezone
    .split(' ')
    .map(word => word[0])
    .join('');
};

export const getDateThreeLetterMonth = (date: string) => {
  if (!date) return;

  const userDate = new Date(date);
  const options: Intl.DateTimeFormatOptions = { timeZone: getUserTimezone(), month: 'short' };
  return userDate.toLocaleString('en-US', options);
};

export const getDateDayNumber = (date: string) => {
  if (!date) return;

  //userdate in utc
  const userDate = new Date(date);
  const options: Intl.DateTimeFormatOptions = { timeZone: getUserTimezone(), day: 'numeric' };
  return userDate.toLocaleString('en-US', options);
};
